'use strict'

export default class PeakRowProxy {


    /**
     * @param {PeakRow} target
     * @param {{}} col?
     */
    constructor(target, col = {}) {
        this._target = target;
        this._values = col;
        this._displayValues = {};
    }

    get id() {
        return this.injection.id + '-' + this.peak.id
    }

    get injection(){
        return this._target.injection;
    }

    get peak(){
        return this._target.peak;
    }

    get substance(){
        return this._target.substance;
    }

    get chromatogram(){
        return this._target.chromatogram
    }

    get col() {
        return this._values;
    }

    /**
     * @param {string} colName
     * @param {*}value
     */
    setDisplayValue(colName, value){
        this._displayValues[colName] = value
    }

    /** @param {string} colName */
    removeDisplayValue(colName){
        delete this._displayValues[colName]
    }

    /**
     * @param {string} colName
     * @returns {*}
     */
    getDisplayValue(colName) {
        if (this._displayValues.hasOwnProperty(colName))
            return this._displayValues[colName];
        return this._values[colName];
    }
}